/*
 * Copyright (c) 2022-2022. Revo Digital
 * ---
 * Author: gabriele
 * File: Transformers.ts
 * Project: mle-client-n
 * Committed last: 2022/1/18 @ 1637
 * ---
 * Description:
 */

import { Editor }                                 from '../../../store/observables/Editor';
import { measureUnitToPixel, pixelToMeasureUnit } from '../../measure-unit-utils';

export const defaultMeasureUnitTransformer = (editor: Editor) => ({
  onDisplay: (displayedValue: number) => pixelToMeasureUnit(editor.projectData.projectOptions.measureUnit,
    displayedValue),
  onEnter: (enteredValue: number) => measureUnitToPixel(editor.projectData.projectOptions.measureUnit,
    enteredValue)
});

export const defaultStringTransformer = (editor: Editor) => ({
  onDisplay: (displayedValue: string) => displayedValue,
  onEnter: (enteredValue: string) => {
    return enteredValue;
  }
});
